import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import 'brace/mode/javascript';

@Component({
  selector: 'functions-code-modal',
  templateUrl: './functions-code-modal.component.html',
})
export class FunctionsCodeModalComponent {
  constructor(private ngxSmartModalService: NgxSmartModalService) {}
  @Input() dynFunction: any;

  objectKeys = Object.keys;
  options: any = { maxLines: 1000, printMargin: true };

  save(): void {
    this.ngxSmartModalService.getModal(this.dynFunction.name).close();
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/functions/functions-code-modal.component.ts